import { kasplexTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { getAddress } from 'viem'
import { SerializedFarmConfig } from '..'
import { defineFarmV3Configs } from '../src/defineFarmV3Configs'

export const farmsV3 = defineFarmV3Configs([
  {
    pid: 1,
    lpAddress: '0x723beee8aa1eaef57002f28d5a43f5a274b1a2c2',
    token0: kasplexTokens.wkas,
    token1: kasplexTokens.usdt,
    feeAmount: FeeAmount.LOWEST,
  },
  {
    pid: 2,
    lpAddress: '0x41f514B4a854736213A2b222116688D76108fd50',
    token0: kasplexTokens.usdc,
    token1: kasplexTokens.usdt,
    feeAmount: FeeAmount.LOWEST,
  },
  {
    pid: 3,
    lpAddress: '0xa644e8860665ca3beb98458f700c80bf3f87bd82',
    token0: kasplexTokens.fcn,
    token1: kasplexTokens.usdt,
    feeAmount: FeeAmount.LOWEST,
  },
  {
    pid: 4,
    lpAddress: '0x110164e49a797b573700ba3d7930af54d34efb4e',
    token0: kasplexTokens.usdc,
    token1: kasplexTokens.wkas,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 5,
    lpAddress: '0x406324958C20380147770b8087641998dcA014B2',
    token0: kasplexTokens.wkas,
    token1: kasplexTokens.usdt,
    feeAmount: FeeAmount.MEDIUM,
  },
])

const farms: SerializedFarmConfig[] = [
  {
    pid: 1,
    lpSymbol: 'WKAS-USDT LP',
    lpAddress: '0x723beee8aa1eaef57002f28d5a43f5a274b1a2c2',
    token: kasplexTokens.wkas,
    quoteToken: kasplexTokens.usdt,
  },
  {
    pid: 2,
    lpSymbol: 'USDC-USDT LP',
    lpAddress: '0x41f514b4a854736213a2b222116688d76108fd50',
    token: kasplexTokens.usdc,
    quoteToken: kasplexTokens.usdt,
  },
  {
    pid: 3,
    lpSymbol: 'FCN-USDT LP',
    lpAddress: '0xa644e8860665ca3beb98458f700c80bf3f87bd82',
    token: kasplexTokens.fcn,
    quoteToken: kasplexTokens.usdt,
  },
  {
    pid: 4,
    lpSymbol: 'USDC-WKAS LP',
    lpAddress: '0x110164e49a797b573700ba3d7930af54d34efb4e',
    token: kasplexTokens.usdc,
    quoteToken: kasplexTokens.wkas,
  },
  {
    pid: 5,
    lpSymbol: 'WKAS-USDT LP',
    lpAddress: '0x406324958C20380147770b8087641998dcA014B2',
    token: kasplexTokens.wkas,
    quoteToken: kasplexTokens.usdt,
  },
].map((p) => ({
  ...p,
  token: p.token.serialize,
  quoteToken: p.quoteToken.serialize,
  lpAddress: getAddress(p.lpAddress),
}))

export default farms
